import React from 'react';
import styled from 'styled-components';
import { FaPhoneAlt, FaWhatsapp, FaTruck } from 'react-icons/fa';

const TowTruckContainer = styled.section`
  padding: 80px 0;
  background: #4F4C4C;
  color: #ffffff;
  text-align: center;
`;

const TowTruckWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
`;

const TowTruckIcon = styled.div`
  font-size: 5rem;
  color: #c77408;
  margin-bottom: 20px;
`;

const TowTruckH1 = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

const TowTruckP = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
`;

const Button = styled.a`
  border-radius: 50px;
  background: #c77408;
  white-space: nowrap;
  padding: 14px 30px;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  outline: none;
  border: 2px solid #c77408;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    background: transparent;
    border-color: #ffffff;
    color: #ffffff;
  }
`;

const TowTruck = () => {
  return (
    <TowTruckContainer id="towtruck">
      <TowTruckWrapper>
        <TowTruckIcon><FaTruck /></TowTruckIcon>
        <TowTruckH1>PRECISOU DE AJUDA? GUINCHO 24H!</TowTruckH1>
        <TowTruckP>
          Ficou na estrada? Nosso guincho 24h, comandado por Valdeci, está pronto para te atender a qualquer hora do dia.
        </TowTruckP>
        <ButtonWrapper>
          <Button href="tel:5562981229756">
            <FaPhoneAlt style={{ marginRight: '8px' }} /> LIGAR AGORA
          </Button>
          <Button href="https://api.whatsapp.com/send?phone=5562981229756" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp style={{ marginRight: '8px' }} /> CHAMAR NO WHATSAPP
          </Button>
        </ButtonWrapper>
      </TowTruckWrapper>
    </TowTruckContainer>
  );
};

export default TowTruck;